'use strict';

var _ = require('../mindash');

module.exports = function (marty, React) {
  _.extend(marty, require('./createContainer')(React));
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/container/index.js
 ** module id = 551
 ** module chunks = 0
 **/